import React, { useState, useContext, useCallback, useEffect } from "react"
import styles from "../../../styles/Page-with-Sidebar.module.css"
import { InputText } from "primereact/inputtext"
import { UserContext } from "../../../context/userContext"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { getTimeAgo, sortListByDate, truncateString } from "../Utils"
import { Checkbox } from "primereact/checkbox"
import { Button } from "primereact/button"
import { LoaderMedium } from "../../../components/Loaders"

import {
  trApiGetSMSConversations,
  trApiSMSGetBulkHistory,
  trApiSMSSetRead,
} from "../telerecoveryApi"

export default function LeftConvList({
  participants,
  openNewParticipantChat,
  openConv,
  setHasConvs,
  convList,
  setConvList,
  staffNumber,
}) {
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [filteredConvList, setFilteredConvList] = useState([])
  const [selectedConv, setSelectedConv] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [showSearch, setShowSearch] = useState(false)
  const [unreadFilter, setUnreadFilter] = useState(false)

  useEffect(() => {
    if (convList) {
      let updatedFilteredConvList = convList.filter(
        (s) =>
          searchTerm === "" ||
          s.caseName.toLowerCase().includes(searchTerm.toLowerCase()),
      )
      sortListByDate(updatedFilteredConvList, "lastMessageDate")
      setFilteredConvList(updatedFilteredConvList)
    }
  }, [convList])

  const selectConversation = (conv) => {
    setSelectedConv(conv.caseId)
    markConversationRead(conv.casePhone, conv.caseId)
    openConv({
      sid: conv.caseId,
      participant: {
        id: conv.caseId,
        phone: conv.casePhone,
        name: conv.caseName,
        initials: conv.caseInitials,
      },
    })
  }

  const markConversationRead = useCallback(
    (casePhone, caseId) => {
      if (convList) {
        let data = {
          participantNumber: casePhone,
          staffNumber: staffNumber,
        }
        trApiSMSSetRead(userCtx.tokens.getTelerecoveryToken(), data).then(
          (resp) => {
            const updatedList = convList.map((conv) => {
              if (conv.caseId === caseId) {
                return { ...conv, containsUnread: false }
              }
              return conv
            })
            setConvList(updatedList)
          },
        )
      }
    },
    [convList],
  )

  const loadConvList = useCallback(
    () => {
      trApiGetSMSConversations(
        userCtx.tokens.getTelerecoveryToken(),
        user.staff_id,
      )
        .then(
          (response) => {
            let _convList = Array.from(response)
            let formattedConvList = []
            _convList.forEach((conv) => {
              let participant = participants.find(
                (s) => conv.caseId === s.participant_id,
              )
              if (participant) {
                // if i found the data for the specific participant, then i build the formated obj and
                // i add it to the list
                let convReqData = {
                  caseId: conv.caseId,
                  caseName: participant.name,
                  casePhone: participant.participant_phone_primary,
                  lastMessageDate: conv.lastMessageDate,
                  containsUnread: conv.containsUnread,
                }

                if (convReqData.caseId.toString() !== "NaN") {
                  if (
                    !formattedConvList.find(
                      (s) => s.caseId === convReqData.caseId,
                    )
                  )
                    formattedConvList.push(convReqData)
                }
              }
            })

            // The fetch is being triggered more than once on load - requires deeper investigation
            trApiSMSGetBulkHistory(
              userCtx.tokens.getTelerecoveryToken(),
              staffNumber.replace(/\D/g, ""),
              user.organization_id,
              formattedConvList,
            )
              .then(
                (response) => {
                  let convBulkHistory = Array.from(response)
                  convBulkHistory = convBulkHistory.map((conv) => {
                    const participant = participants.find(
                      (s) => conv.caseId === s.participant_id,
                    )
                    if (participant) {
                      conv.caseInitials = participant.initials
                    }
                    return conv
                  })
                  setConvList(convBulkHistory)
                  setHasConvs(convBulkHistory.length > 0)
                  if (convBulkHistory.length > 0) {
                    selectConversation(convBulkHistory[0])
                  }
                  userCtx.setGmParticipantsConvList(convBulkHistory)
                },
                (err) => console.log(err),
              )
              .catch((err) => console.log(err))
              .finally(() => {
                setIsLoading(false)
              })
          },
          (err) => console.log(err),
        )
        .catch((err) => console.log(err))
        .finally(() => {
          setIsLoading(false)
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [participants],
  )

  useEffect(() => {
    loadConvList()
  }, [loadConvList])

  const search = (sTerm) => {
    setSearchTerm(sTerm)
    setFilteredConvList(
      convList.filter(
        (s) =>
          sTerm === "" ||
          s.caseName.toLowerCase().includes(sTerm.toLowerCase()),
      ),
    )
  }

  if (isLoading) {
    return <LoaderMedium />
  }

  if (convList && convList.length > 0) {
    return (
      <div
        className={styles.conversations_menu}
        style={{ backgroundColor: "#e7e0f180", paddingRight: "10px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "44px",
            marginBottom: "30px",
          }}
        >
          {!showSearch && (
            <Button
              className={gMessages.searchBtn}
              icon="pi pi-search"
              onClick={() => setShowSearch(true)}
            />
          )}
          {!showSearch && (
            <Button
              className={`custom_button_icon ${gMessages.newChatBtn}`}
              label="New SMS"
              icon="pi pi-plus"
              onClick={() => {
                openNewParticipantChat()
                setSelectedConv(null)
              }}
            />
          )}
          {showSearch && (
            <span className="p-input-icon-left" style={{ width: "100%" }}>
              <i className="pi pi-search" />
              <InputText
                className={gMessages.searchInput}
                value={searchTerm}
                onChange={(e) => search(e.target.value)}
                placeholder="Search"
              />
              <Button
                className={`custom_button_icon ${gMessages.closeBtn}`}
                icon="pi pi-times"
                onClick={() => {
                  setShowSearch(false)
                  setSearchTerm("")
                  setFilteredConvList(convList)
                }}
              />
            </span>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 style={{ color: "#383838", fontSize: "16px", fontWeight: "700" }}>
            Recents
          </h3>
          <div className={gMessages.checkbox_unread}>
            <Checkbox
              inputId="unreadFilter"
              onChange={(e) => {
                setUnreadFilter(e.checked)
                setFilteredConvList(
                  convList.filter((s) => (e.checked ? s.containsUnread : true)),
                )
              }}
              checked={unreadFilter}
            />
            <label
              style={{ color: "#383838", fontSize: "14px" }}
              htmlFor="unreadFilter"
            >
              Unread
            </label>
          </div>
        </div>
        {filteredConvList.length === 0 && (
          <h3
            key="no_chats"
            style={{
              marginTop: "20px",
              textAlign: "center",
              color: "#383838",
              fontSize: "20px",
            }}
          >
            No chats
          </h3>
        )}
        <ul
          className={`${gMessages.chatConvListContainer} ${gMessages.myScrollbar}`}
        >
          {filteredConvList &&
            filteredConvList.map((conv) => {
              return (
                <li
                  key={conv.sid}
                  onClick={() => {
                    selectConversation(conv)
                  }}
                  style={{ width: "100%", position: "relative" }}
                >
                  <div
                    className={`${gMessages.convElement} ${selectedConv === conv.caseId && gMessages.selected}`}
                  >
                    <span className={gMessages.userInitials}>
                      {conv.caseInitials}
                    </span>
                    <div>
                      <p>{truncateString(conv.caseName, 22)}</p>
                      <p className={gMessages.timeAgo}>
                        {getTimeAgo(conv.lastMessageDate)}
                      </p>
                    </div>
                  </div>
                  {conv.containsUnread && (
                    <span className={gMessages.unread}></span>
                  )}
                </li>
              )
            })}
        </ul>
      </div>
    )
  }

  return (
    <div
      className={styles.conversations_menu}
      style={{ backgroundColor: "#e7e0f180" }}
    ></div>
  )
}
